/**
 * ENV
 */
export const ENVIRONMENT = process.env.REACT_APP_ENV;

/**
 * CREDENTIALS
 **/
export const CREDENTIALS_TYPE_LOGIN = "Login";
export const CREDENTIALS_TYPE_PHONE = "Telefono";
export const CREDENTIALS_TYPE_EMAIL = "Email";

export const CREDENTIALS_DESTINATION_TYPE_SMS = "sms";
export const CREDENTIALS_DESTINATION_TYPE_EMAIL = "correo";

/**
 * SECTIONS
 **/
export const SECTION_USER_MANAGEMENT = "gestion-usuarios";
export const SECTION_USERS = "usuarios";
export const SECTION_DEVICES = "dispositivos";
export const SECTION_SESSIONS = "sesiones";
export const SECTION_UPDATE_CREDENTIALS = "update-credentials";
export const SECTION_VALIDATE_CREDENTIALS = "validate-credentials";
export const SECTION_BLOCK_USER = "block-user";
export const SECTION_DFA_STATUS_UPDATE = "dfa-status-update";
export const SECTION_UPDATE_LOGIN = "update-login";
export const SECTION_LOGIN = "login";

/**
 * SECTIONS TEXT
 **/
export const SECTION_NAME_USER_MANAGEMENT = "menu.user_management";

/**
 * ROUTES
 **/
export const ROUTES_PUBLIC = "/public/masbran/";

export const ROUTES_HOME = `${ROUTES_PUBLIC}`;
export const ROUTES_USER_MANAGEMENT = `${ROUTES_PUBLIC}${SECTION_USER_MANAGEMENT}`;
export const ROUTES_USERS = `${ROUTES_PUBLIC}${SECTION_USERS}`;
export const ROUTES_USER = `${ROUTES_PUBLIC}${SECTION_USERS}/:id`;
export const ROUTES_DEVICES = `${ROUTES_PUBLIC}${SECTION_DEVICES}`;
export const ROUTES_SESSIONS = `${ROUTES_PUBLIC}${SECTION_SESSIONS}`;
export const ROUTES_LOGIN = `${ROUTES_PUBLIC}${SECTION_LOGIN}`;
export const ROUTES_DEFAULT = "*";

/**
 * MENU ROUTES AND SECTIONS
 **/
export const MENU_USER_ROUTES = [SECTION_USER_MANAGEMENT, SECTION_USERS, SECTION_DEVICES, SECTION_SESSIONS];

export const MENU_ROUTES = {
  [SECTION_NAME_USER_MANAGEMENT]: MENU_USER_ROUTES,
};

/**
 * PAGE TITLE
 **/
export const PAGE_TITLE = {
  [SECTION_USERS]: "menu.user_list",
  [SECTION_DEVICES]: "menu.device_list",
  [SECTION_SESSIONS]: "menu.session_list",
  [SECTION_UPDATE_CREDENTIALS]: "menu.credentials_update",
  [SECTION_VALIDATE_CREDENTIALS]: "menu.validate_credentials",
  [SECTION_BLOCK_USER]: "menu.block_user",
  [SECTION_DFA_STATUS_UPDATE]: "menu.dfa_status_update",
  [SECTION_UPDATE_LOGIN]: "menu.login_update",
};

/**
 * DOMAINS
 */
export const EKT_DOMAIN_INT = "ekrt";
export const MM_DOMAIN_INT = "masmovil";

/**
 * API CALLS VALUES
 */
export const DEFAULT_HTTP_TIMEOUT = 60000;
export const PORTAL_CODE = process.env.REACT_APP_PORTAL_CODE;
export const MASBRAN_API_HOST = window.location.origin;
export const MASBRAN_BASE_API_URL = `${MASBRAN_API_HOST}/api/masbran/gestionusuarios`;

/**
 * BACKEND API MASBRAN
 */
//AUTH
export const MASBRAN_API_LOGIN = MASBRAN_API_HOST + `/public/auth-api/masbran/login`;
export const MASBRAN_API_LOGOUT = MASBRAN_API_HOST + `/auth-api/masbran/logout`;
export const MASBRAN_API_CHECK = MASBRAN_API_HOST + `/auth-api/masbran/check`;
export const MASBRAN_API_LOGIN_PERMISSIONS = MASBRAN_API_HOST + `/auth-api/masbran/login-permissions`;

//DATA
export const MASBRAN_API_GET_USERS = MASBRAN_BASE_API_URL + `/user/?`;
export const MASBRAN_API_GET_USERS_CRM = MASBRAN_BASE_API_URL + `/user/?customerId=:idCrm`;
export const MASBRAN_API_GET_USER = MASBRAN_BASE_API_URL + `/customers/:idCrm/users/:idUser`;
export const MASBRAN_API_GET_DEVICES = MASBRAN_BASE_API_URL + `/customers/:idCrm/users/:idUser/devices`;
export const MASBRAN_API_GET_ACTIVE_SESSIONS_BY_USER =
  MASBRAN_BASE_API_URL + `/customers/:idCrm/users/:idUser/sessions`;
export const MASBRAN_API_GET_ACTIVE_SESSIONS = MASBRAN_BASE_API_URL + `/customers/:idCrm/sessions`;
export const MASBRAN_API_POST_UPDATE_CREDENTIAL =
  MASBRAN_BASE_API_URL + `/customers/:idCrm/users/:idUser/update-user-credentials`;
export const MASBRAN_API_POST_VALIDATE_SECURITY_CREDENTIALS =
  MASBRAN_BASE_API_URL + `/customers/:idCrm/users/:idUser/validate-user-credentials`;
export const MASBRAN_API_POST_BLOCK_USER = MASBRAN_BASE_API_URL + `/customers/:idCrm/lock-unlock`;
export const MASBRAN_API_POST_DOUBLE_FACTOR_UPDATE =
  MASBRAN_BASE_API_URL + `/customers/:idCrm/users/:idUser/update-user-dfa`;
export const MASBRAN_API_POST_UPDATE_LOGIN = MASBRAN_BASE_API_URL + `/customers/:idCrm/users/:idUser/update-user-login`;
export const MASBRAN_API_POST_USER_DATA = MASBRAN_BASE_API_URL + `/customers/:idCrm`;
export const MASBRAN_API_DELETE_SESSION = MASBRAN_BASE_API_URL + `/customers/:idCrm/sessions/:idSession`;
export const MASBRAN_API_DELETE_USER = MASBRAN_BASE_API_URL + `/customers/:idCrm/users/:idUser`;

//TODO: endpoints que no se usan
export const MASBRAN_API_POST_VALIDATE_LANDING_CREDENTIALS =
  MASBRAN_BASE_API_URL + `/usuarios/v3/validarCredencialSeguridadLandingIdLogin/:idCrm/:idUsuario`;
export const MASBRAN_API_POST_VALIDATE_LOGIN_CREDENTIALS =
  MASBRAN_BASE_API_URL + `/usuarios/v3/validacionCredencialIdLogin`;
export const MASBRAN_API_POST_REGISTER_DEVICE =
  MASBRAN_BASE_API_URL + `/usuarios/v3/dispositivos/alta/:idCrm/:idUsuarioDispositivo`;

/**
 * REACT ADMIN URLs
 */
export const LIST_USERS_URL = MASBRAN_API_GET_USERS_CRM;
export const LIST_USERS_PARAMS_URL = MASBRAN_API_GET_USERS;
export const LIST_DEVICES_URL = MASBRAN_API_GET_DEVICES;
export const LIST_SESSIONS_URL = MASBRAN_API_GET_ACTIVE_SESSIONS_BY_USER;

/**
 * RESOURCES IDs
 */
export const USUARIOS_ID = "idUsuario";
export const SESIONES_ID = "idSesion";
export const DISPOSITIVOS_ID = "idDispositivo";

export const RESOURCES_IDS = {
  [SECTION_USERS]: USUARIOS_ID,
  [SECTION_SESSIONS]: SESIONES_ID,
  [SECTION_DEVICES]: DISPOSITIVOS_ID,
};

/**
 * LOCALES
 */
export const LOCALE_ES = "es";

/**
 * SESSION CONSTANTS
 */
export const SESSION_TOKEN_STORAGE_KEY = "masbranSessionToken";
export const SESSION_PERMISSIONS_STORAGE_KEY = "masbranSessionPermissions";
export const SESSION_USER_ID_KEY = "masbranUserId";
export const SESSION_SECURITY_ROLE_KEY = "masbranSecurityRole";
export const SESSION_APP_CONTEXT_STORAGE_KEY = "masbranAppContext";
export const SESSION_USER_TENANTS_KEY = "masbranUserTenants";

/**
 * USER
 */
export const USER_GENERIC_NAME = "Usuario";

export const USER_STATUS_BLOCKED = "Bloqueado";
export const USER_STATUS_ACTIVE = "Activo";

export const USER_STATUS_BLOCK = "BLOQUEO";
export const USER_STATUS_UNBLOCK = "DESBLOQUEO";

export const MESSAGE_USER_BLOCK = "messages.block_user";
export const MESSAGE_USER_UNBLOCK = "messages.unblock_user";
export const MESSAGE_USER_CREDENTIAL_UPDATE = "messages.credentials_update";
export const MESSAGE_USER_DFA_UPDATE = "messages.dfa_update";
export const MESSAGE_USER_LOGIN_UPDATE = "messages.login_update";
export const MESSAGE_USER_CREDENTIAL_VALIDATE = "messages.credentials_validate";
export const MESSAGE_USER_LOGIN_VALIDATE = "messages.login_validate";
export const MESSAGE_USER_PERSONAL_INFO_UPDATE = "messages.personal_info_updated";

/**
 * TYPES
 */
export const TYPE_NUMBER = "number";

/**
 * KEYS
 */
export const KEY_ENTER = "Enter";

/**
 * USER ACCORDION
 **/
export const ACCORDION_USER_INFO = "ACCORDION_USER_INFO";
export const ACCORDION_USER_DFA_LOGIN = "ACCORDION_USER_DFA_LOGIN";
export const ACCORDION_USER_SECURITY_CREDENTIALS = "ACCORDION_USER_SECURITY_CREDENTIALS";
export const ACCORDION_USER_PERSONAL_DATA = "ACCORDION_USER_PERSONAL_DATA";

export const ACCORDION_SECTIONS = [
  ACCORDION_USER_INFO,
  ACCORDION_USER_DFA_LOGIN,
  ACCORDION_USER_SECURITY_CREDENTIALS,
  ACCORDION_USER_PERSONAL_DATA,
];

/**
 * DATA GRID
 **/
export const TABLE_ROW_HEIGHT = 65;
export const TABLE_HEADER_HEIGHT = 50;
export const DEFAULT_TABLE_PAGE_SIZE = 5;

/**
 * SEARCH TABS
 **/
export const SEARCH_TAB_ID_CRM = "SEARCH_TAB_ID_CRM";
export const SEARCH_TAB_LOGIN = "SEARCH_TAB_LOGIN";
export const SEARCH_TAB_NIF = "SEARCH_TAB_NIF";

/**
 * ROLES
 **/
export const ROLE_MAS_BRAN = "ROLE_MAS_BRAN";
export const ROLE_GESTION_USUARIOS = "ROLE_GESTION_USUARIOS";

export const MASBRAN_APPS = [
  {
    name: SECTION_USER_MANAGEMENT,
    title: "menu.user_management",
    route: ROUTES_USER_MANAGEMENT,
    role: ROLE_GESTION_USUARIOS,
  },
];

/**
 * EXTERNAL LINKS
 */
export const NEW_CONSOLE_URL = process.env.REACT_APP_NEW_CONSOLE_URL;
